import { render } from "./InterventionDetailModal.vue?vue&type=template&id=40854524&scoped=true"
import script from "./InterventionDetailModal.vue?vue&type=script&lang=js"
export * from "./InterventionDetailModal.vue?vue&type=script&lang=js"

import "./InterventionDetailModal.vue?vue&type=style&index=0&id=40854524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40854524"]])

export default __exports__